export enum CustomSource {
  Osa = "Osa",
  SimplifiedOsa = "SimplifiedOsa",
  Hla = "Hla",
  PlannedTrajectory = "PlannedTrajectory",
  PendingCoordChanges = "PendingCoordChanges",
  CopyNodes = "CopyNodes",
  Projects = "Projects",
  StreetView = "StreetView",
  QueryInfrastructure = "QueryInfrastructure",
  QueryHlaOriginDestination = "QueryHlaOriginDestination",
  Parking = "Parking",
  BusStop = "BusStop",
  Mapillary = "Mapillary"
}
